<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>供应点管理</el-breadcrumb-item>
        <el-breadcrumb-item>基地对账</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="基地名称：">
              <el-select clearable size="small" v-model="listParams.farmId" style="width: 100%" placeholder="请选择基地名称">
                <el-option v-for="item in baseNameList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select clearable style="width: 100%" v-model="listParams.date" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.dateId" :key="item.dateId" :label="item.date | formatDate"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="printTableData">-->
          <!--打印-->
          <!--</el-button>-->
          <!-- <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span> -->
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" show-summary :summary-method="getSummaries" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="goodsTitle" align="center" label="商品名称"> </el-table-column>

        <el-table-column prop="specTitle" align="center" label="规格"> </el-table-column>

        <el-table-column prop="quantity" align="center" label="总数量"> </el-table-column>

        <el-table-column prop="price" align="center" label="单价">
          <template slot-scope="scope">
            <span>{{ scope.row.price | formatToFixed2("元") }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="total" align="center" label="总价">
          <template slot-scope="scope">
            <span>{{ scope.row.total | formatToFixed2("元") }}</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        supplyId: "",
        id: 1,
        farmId: "",
        date: "",
      },
      baseNameList: [],
      dateList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  async mounted() {
    this.listParams.id = this.$route.params.supplyCentreId;
    this.listParams.supplyId = this.$route.params.supplyId;
    await this.loadBaseNameList();
    await this.loadDateList();
  },
  methods: {
    /**
     * 初始化基地名称列表
     */
    loadBaseNameList() {
      this.$http({
        url: global.apiUrl + "/farm/title",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.baseNameList = res.body.data.dataList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/logistics/goods-management-date",
        method: "GET",
        params: {
          id: this.listParams.id,
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dateList = res.body.data.dateList;
              this.listParams.date = res.body.data.dateList[0].dateId;
              this.loadTableData();
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      });
      this.$http({
        url: global.apiUrl + "/logistics/checkingNew",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 打印列表
     */
    printTableData() {},
    /**
     * 获取合计数据
     * @param param
     */
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "金额总计";
          return;
        }
        if (column.property === "total") {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toFixed(2) + "元";
          }
        }
      });
      return sums;
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.listParams.id = parseInt(vm.$route.params.supplyCentreId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
